import { Dispatch, SetStateAction, createContext, useContext } from 'react';

type EphemeralEmailContext = {
  clear: Function;
  email?: string;
  setEmail: Dispatch<SetStateAction<string | undefined>>;
};

const defaultValue: EphemeralEmailContext = {
  clear: () => null,
  email: undefined,
  setEmail: () => null,
};

const context = createContext(defaultValue);
const { Provider } = context;
const useEphemeralEmail = (): EphemeralEmailContext =>
  useContext<EphemeralEmailContext>(context);

export { EphemeralEmailContext, Provider, defaultValue, useEphemeralEmail };
